import {
  CondensedButton,
  Heading,
  IconExternalLinkLine,
  IconInfoSolid,
  Spinner,
  Table,
  Tooltip,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import { ShareCodeService } from "../../../../services/ShareCodeService";
import { TermsContext } from "../../../../utils/Context";
import { Card } from "../../../Card";
import {
  ERROR,
  useNotification,
} from "../../../CustomHooks/NotificationProvider";
import { buildRatingScaleMaps } from "./utils";

export const ExternalDetails = ({ planId, assessment }) => {
  const { t } = useTranslation();
  const { canvasTerms, insightsTerms } = useContext(TermsContext);
  const showNotification = useNotification();

  const ExternalLink = ({ term }) => {
    const [sending, setSending] = useState(false);

    const handleSendJAorExternalPurl = (assessment, termId) => {
      setSending(true);
      const shareData = {
        shared_path: "/external-assessment",
        external_user_ids:
          typeof assessment.assessors === "string"
            ? assessment.assessors.split(",")
            : assessment.assessors,
        context: { assessment_id: assessment.id },
      };
      shareData.context.purl_id = assessment.purl_id;
      shareData.context.term_id = termId;
      shareData.context.plan_id = planId;
      shareData.context.lo_rating_scale_maps = buildRatingScaleMaps(assessment);
      shareData.context.assessment_type = "external";
      ShareCodeService.createShareUrl(shareData)
        .then(() =>
          showNotification(t("notifications.shareCode.sendExternalSuccess"))
        )
        .catch(() =>
          showNotification(
            t("notifications.shareCode.sendExternalError"),
            ERROR
          )
        )
        .finally(() => setSending(false));
    };

    return (
      <CondensedButton
        renderIcon={
          sending ? (
            <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
          ) : (
            IconExternalLinkLine
          )
        }
        onClick={() => handleSendJAorExternalPurl(assessment, term)}
        interaction={!!planId && !sending ? "enabled" : "disabled"}
      >
        {t("assessment.sendOutExternal")}
      </CondensedButton>
    );
  };

  return (
    <Card style={{ marginRight: "18px" }}>
      <Heading as="h3" level="h5" border="bottom" margin="0 0 small 0">
        {t("assessment.termsToBeAssessed")}:{" "}
      </Heading>
      <Table caption={t("assessment.termsToBeAssessed")}>
        <Table.Head>
          <Table.Row>
            <Table.ColHeader id="term">
              {t("results.resultsModeByTerm")}
            </Table.ColHeader>
            <Table.ColHeader id="link">
              {t("assessment.link")}{" "}
              <Tooltip
                renderTip={
                  <div style={{ maxWidth: 500 }}>
                    {t("assessment.resendExternalMessage")}
                  </div>
                }
                placement="end"
                on={["click", "hover", "focus"]}
                color="primary-inverse"
              >
                <IconInfoSolid color="brand" />
              </Tooltip>
            </Table.ColHeader>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {assessment.assessing_terms.map((term, key) => (
            <Table.Row key={key}>
              <Table.Cell>
                {
                  insightsTerms.find(
                    (insightsTerm) =>
                      canvasTerms.find((canvasTerm) => canvasTerm.id === term)
                        .insights_term_id === insightsTerm.id
                  ).name
                }
              </Table.Cell>
              <Table.Cell>
                <ExternalLink term={term} />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Card>
  );
};
